import { translate } from '@utils';
import { HeadCell } from '@types';

export const headCells: HeadCell[] = [
  {
    id: 'owner.firstName',
    disablePadding: true,
    label: translate('respondent'),
    filterKeys: ['fullName'],
    filterType: 'text',
    testId: 'answers-filter-respondent',
  },
  {
    id: 'unit',
    disablePadding: true,
    label: translate('unit'),
    filterKeys: ['unitName'],
    filterType: 'text',
    hideSortIcon: true,
    testId: 'answers-filter-unit',
  },
  {
    id: 'answer.createdAt',
    disablePadding: false,
    label: translate('created_at'),
    filterKeys: ['from', 'to'],
    filterType: 'date',
    testId: 'answers-filter-date',
  },
  {
    id: 'status',
    disablePadding: false,
    label: translate('status'),
    filterKeys: ['status'],
    filterType: 'status',
    hideSortIcon: true,
    testId: 'answers-filter-status',
  },
  {
    id: 'editedBy.firstName',
    disablePadding: false,
    label: translate('edited_by'),
    filterKeys: ['editedByFullName'],
    filterType: 'text',
    testId: 'answers-filter-edited-by',
  },
  {
    id: 'questionnaire.title',
    disablePadding: false,
    label: translate('title'),
    filterKeys: ['questionnaireTitle'],
    filterType: 'select',
    testId: 'answers-filter-title',
  },
  {
    id: 'responsibleHrManager.firstName',
    disablePadding: false,
    label: translate('hr'),
    filterKeys: ['hrFullName'],
    filterType: 'text',
    testId: 'answers-filter-hr',
  },
];
